import MyTable from './components/Table';
const $table = $('#dn-sokuhou-mondai_k-table');
const $categories = $table.find('tr');
const categories = [];
$categories.each(function() {
  const $category = $(this);
  const $links = $category.find('a');
  const links = [];
  $links.each(function() {
    const $link = $(this);
    links.push({
      name: $link.html(),
      id  : $link.attr('data-url_id'),
    })
  });

  categories.push({
    name  : $category.find('th').html(),
    status: $category.attr('data-status'),
    links,
  });
});

MyTable.computed = Object.assign({categories: () => categories}, MyTable.computed);

dn.one('mount', () => {
  new Vue({
    render: h => h(MyTable),
    el: $table.get(0),
    parent: dn,
  });
});



// WEBPACK FOOTER //
// ./src/js/sokuhou/mondai_k/index.js